import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import "@/App.css";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Portfolio from "@/pages/Portfolio";
import ProjectDetail from "@/pages/ProjectDetail";
import Process from "@/pages/Process";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQs from "@/pages/FAQs";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import Consultation from "@/pages/Consultation";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";
import { Privacy, Terms, Cookies } from "@/pages/Legal";
import SearchPage from "@/pages/SearchPage";

import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AdminEnquiries, AdminEnquiryDetail } from "@/pages/admin/AdminEnquiries";
import { AdminProjects } from "@/pages/admin/AdminProjects";
import { AdminServices, AdminBlog, AdminTestimonials, AdminFAQs, AdminTeam, AdminInstagram } from "@/pages/admin/AdminCrud";
import { AdminMedia } from "@/pages/admin/AdminMedia";
import { AdminSettings } from "@/pages/admin/AdminSettings";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="enquiries/:id" element={<AdminEnquiryDetail />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="testimonials" element={<AdminTestimonials />} />
            <Route path="faqs" element={<AdminFAQs />} />
            <Route path="team" element={<AdminTeam />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="instagram" element={<AdminInstagram />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Public site */}
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/:slug" element={<ProjectDetail />} />
            <Route path="/process" element={<Process />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}
